export const API_TOKEN = 'XkxvE9Oa8rN64ZvnSb1Ak3MnLJtNFWJocEaZlWcmWvI=';

export function logout() {
  localStorage.removeItem('isLoggedIn');
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  // Reload so App re-checks login state
  window.location.reload();
}

export async function refreshAccessToken() {
  const refreshToken = localStorage.getItem('refreshToken');
  if (!refreshToken) {
    throw new Error('No refresh token');
  }

  const resp = await fetch(
    'https://demo.api.da-capital.io/v1/auth/admin/refresh',
    {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${refreshToken}`,
        token: API_TOKEN,
      },
    }
  );

  if (!resp.ok) {
    if (resp.status === 400) {
      // Token refresh failed with Bad Request (likely expired)
      logout();
    }
    throw new Error(`Failed to refresh token: ${resp.status}`);
  }

  const data = await resp.json();
  if (data.accessToken) {
    localStorage.setItem('accessToken', data.accessToken);
  }
  if (data.refreshToken) {
    localStorage.setItem('refreshToken', data.refreshToken);
  }

  return data.accessToken;
}

export async function authFetch(url, options = {}) {
  const accessToken = localStorage.getItem('accessToken');
  const opts = {
    ...options,
    headers: {
      ...(options.headers || {}),
      Authorization: `Bearer ${accessToken}`,
      token: API_TOKEN,
    },
  };

  let resp = await fetch(url, opts);

  if (resp.status === 400) {
    // Token is no longer valid; log out immediately
    logout();
    // We won't try to refresh, just return the response so callers can handle
    return resp;
  }

  if (resp.status === 401 || resp.status === 402) {
    try {
      const newToken = await refreshAccessToken();
      const retryOpts = {
        ...opts,
        headers: {
          ...(opts.headers || {}),
          Authorization: `Bearer ${newToken}`,
          token: API_TOKEN,
        },
      };
      resp = await fetch(url, retryOpts);
    } catch (err) {
      // If refresh fails, propagate original response
      throw err;
    }
  }

  return resp;
}
